import React, { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import UserAvatar from '../../../../User/Avatar';
import { CommentContext } from '../../../CommentContext';
import CommentFooter from '../../../lego/CommentFooter';
import ReplyCommentBox from '../../../lego/ReplyCommentBox';
import ReadContentBlock from '../../../lego/ReadContentBlock';
import RootLayout from './RootLayout';
import s from './ReadView.scss';
/**
 * The read view for our standard comment preset.
 */ const ReadView = ({ canPostComment, nc, includeFooter = true, onReplyPosted })=>{
    const isMobile = useContext(MobileContext);
    const { comment, isReplying } = useContext(CommentContext);
    const { user } = comment;
    const canReply = !comment.isHidden && !comment.isSpam;
    return /*#__PURE__*/ React.createElement(RootLayout, {
        prefix: user && /*#__PURE__*/ React.createElement(UserAvatar, {
            user: user,
            size: isMobile ? 24 : 32,
            withTooltip: true
        }),
        contentBlocks: [
            /*#__PURE__*/ React.createElement(ReadContentBlock, {
                key: "main-content",
                canPostComment: canPostComment
            }),
            includeFooter && /*#__PURE__*/ React.createElement(CommentFooter, {
                key: "footer",
                className: s['footer'],
                canPostComment: canPostComment
            }),
            isReplying && canReply && /*#__PURE__*/ React.createElement(ReplyCommentBox, {
                key: "reply",
                nc: nc,
                className: s['reply-block'],
                onReplyPosted: onReplyPosted,
                canPostComment: canPostComment
            })
        ]
    });
};
ReadView.displayName = 'ReadView';
export default ReadView;

//# sourceMappingURL=ReadView.js.map